async function sleep<T = any>(ms: number, inheritData?: T): Promise<T> {
  return new Promise(resolve => setTimeout(() => resolve(inheritData), ms));
}

export { sleep };
